import { ChecksumAddress, ProtocolInstance } from "@silo/types";
import { createSiloRepositoryContract } from "./createContract";
import { FallbackProvider } from "@ethersproject/providers";

// TODO: consider, less expensive (and less secure) option is to go against
// the graph markets and see if address in the whole set of markets
export const isSilo = async (
  provider: FallbackProvider,
  protocolInstance: ProtocolInstance,
  siloAddress: ChecksumAddress
) => {
  const siloRepositoryContract = createSiloRepositoryContract({
    protocolInstance,
    provider,
  });

  let result;
  try {
    result = await siloRepositoryContract.isSilo(siloAddress);
  } catch (err) {
    console.warn("invalid silo url param provided", err);
  }
  return !!result;
};
